import React from "react";
import {
  Container,
  Title,
  Text,
  Stack,
  Box,
  Paper,
  rem,
  Badge,
  Grid,
  ThemeIcon,
  Group,
  Anchor,
} from "@mantine/core";
import {
  IconMail,
  IconMapPin,
  IconBuildingSkyscraper,
  IconHeart,
} from "@tabler/icons-react";
import { useTranslation } from "../context/TranslationContext";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <Box pb={rem(120)}>
      {/* 1. HEADER SECTION */}
      <Container size="lg" pt={rem(80)} pb={rem(40)}>
        <Stack gap="xs" align="center">
          <Badge variant="dot" color="blue" size="lg">
            {t("contactBadge", "Get in Touch")}
          </Badge>
          <Title
            order={1}
            size={rem(48)}
            ta="center"
            fw={900}
            style={{ letterSpacing: rem(-1) }}
          >
            {t("reachUs", "Reach Us")}
          </Title>
          <Text c="dimmed" size="lg" ta="center" maw={600}>
            {t(
              "contactTagline",
              "Have questions about our paneer or your order? We are here to help."
            )}
          </Text>
        </Stack>
      </Container>

      <Container size="lg" mt={rem(40)}>
        <Grid gutter={rem(80)} align="stretch">
          {/* COLUMN 1: OFFICIAL ADDRESS & CREDENTIALS */}
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap="xl">
              <Box>
                <Group gap="sm" mb="md">
                  <ThemeIcon size="lg" radius="xl" color="blue" variant="light">
                    <IconBuildingSkyscraper size={20} />
                  </ThemeIcon>
                  <Title order={2} size={rem(28)} fw={800}>
                    INDUB AG
                  </Title>
                </Group>

                <Paper withBorder p="xl" radius="lg" bg="gray.0">
                  <Stack gap="sm">
                    <Group align="flex-start" wrap="nowrap">
                      <IconMapPin
                        size={20}
                        color="var(--mantine-color-blue-6)"
                        style={{ marginTop: rem(4) }}
                      />
                      <Box>
                        <Text fw={700} size="lg">
                          Riedmatt 16
                        </Text>
                        <Text c="gray.7" size="lg">
                          6300 ZUG
                        </Text>
                        <Text c="dimmed" size="sm" mt="xs">
                          Switzerland
                        </Text>
                      </Box>
                    </Group>
                  </Stack>
                </Paper>
              </Box>

              {/* Optional: Visual separator or Small Note */}
              {/* <Text size="sm" c="dimmed" italic>
                {t(
                  "addressNote",
                  "Our administrative office in the heart of Zug."
                )}
              </Text> */}
            </Stack>
          </Grid.Col>

          {/* COLUMN 2: THE "LOVE YOUR FEEDBACK" BUBBLE */}
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Box
              p={rem(60)}
              bg="blue.0"
              h="100%"
              style={{
                borderRadius: "40% 60% 60% 40% / 60% 40% 40% 60%", // Signature organic shape
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack gap="xl" align="center">
                <ThemeIcon
                  size={50}
                  radius="xl"
                  color="blue"
                  variant="white"
                  shadow="sm"
                >
                  <IconHeart size={28} color="var(--mantine-color-red-5)" />
                </ThemeIcon>

                <Box>
                  <Title order={3} size={rem(32)} fw={900}>
                    {t("feedbackTitle", "We Love Your Feedback!")}
                  </Title>
                  <Text size="lg" c="gray.7" mt="md" maw={350}>
                    {t(
                      "feedbackText",
                      "Share your Yogi Paneer experiences with us. We'd love to hear how you're enjoying our products."
                    )}
                  </Text>
                </Box>

                <Anchor
                  href="mailto:yogipaneer@gmail.com"
                  underline="none"
                  w="100%"
                  aria-label="Email us at yogipaneer@gmail.com"
                >
                  <Paper
                    withBorder
                    radius="xl"
                    px="xl"
                    py="md"
                    bg="white"
                    style={{
                      transition: "transform 0.2s ease",
                      cursor: "pointer",
                    }}
                    className="email-hover-card"
                  >
                    <Group justify="center" gap="sm">
                      <IconMail size={22} color="var(--mantine-color-blue-6)" aria-hidden="true" />
                      <Text fw={700} size="lg" c="blue.7">
                        yogipaneer@gmail.com
                      </Text>
                    </Group>
                  </Paper>
                </Anchor>
              </Stack>
            </Box>
          </Grid.Col>
        </Grid>
      </Container>
    </Box>
  );
}
